module.exports = __webpack_public_path__ + "static/media/logo.182d7cf2.png";